//
import MainFooter from './MainFooter';
import MainHeader from './MainHeader';

/* ============================================================================
   Layout `main` (site publico) - visual novo (shadcn + Tailwind).

   Substitui `Stack`/`Box`/`Container`/`Typography` do MUI por flex do Tailwind.

   ESTADO REAL DESTE LAYOUT (conferido, porque muda o que faz sentido investir
   aqui): so tres paginas pedem `Layout variant="main"` - pages/index.jsx,
   pages/[token].jsx e pages/dashboard/index.jsx - e as tres renderizam apenas
   <LoadingScreen /> enquanto redirecionam. A LoadingScreen e `position: fixed`
   com `z-index: 99999`, ou seja, ela cobre este layout inteiro. Na pratica o
   cabecalho e o rodape daqui nao chegam a ser vistos hoje. Foram migrados
   (nao apagados) porque o layout continua sendo o ponto de entrada de qualquer
   pagina publica futura.

   O QUE MUDOU:

   1. Havia DOIS rodapes: `MainFooter` fora da home e, na home, um bloco proprio
      com o logo e o texto "made by minimals.cc" - anuncio do template, com link
      para fora do produto. Sobrou um rodape unico; a bifurcacao `isHome` existia
      apenas para trocar um rodape de verdade por esse credito, e por isso o
      `useRouter` tambem saiu daqui.

   2. `min-h-screen` + `mt-auto` no rodape substituem o `<Box sx={{flexGrow:1}}/>`
      vazio que era usado como espacador - um elemento a menos no DOM para o mesmo
      efeito de "rodape colado embaixo mesmo com pouco conteudo".
   ============================================================================ */

export default function MainLayout({ children }) {
  return (
    <div className="flex min-h-screen flex-col bg-fundo">
      <MainHeader />

      {children}

      <div className="mt-auto">
        <MainFooter />
      </div>
    </div>
  );
}
